import React from 'react';
export function PreviewSection() {
  return <section className="py-20 bg-[#FFF8F0]" data-id="element-135">
      <div className="max-w-6xl mx-auto px-4" data-id="element-136">
        <div className="text-center mb-12" data-id="element-137">
          <span className="text-[#BE185D] font-bold tracking-wider uppercase mb-2 block" data-id="element-138">
            👀 Mirá por dentro
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-139">
            Así se ve el contenido real del MegaPack
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-140">
            Material profesional, claro y estructurado. Sin relleno, sin teoría
            innecesaria. Directo a lo que necesitás saber.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-141">
          <div className="rounded-xl overflow-hidden shadow-lg border border-pink-100 bg-white" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/qzpjFkpeZGYHJaVJTa3ryy/Screenshot_2026-02-13_202516.png" alt="Módulo 2 – Equipos y Seguridad" className="w-full h-auto" data-id="element-143" />
          </div>
          <div className="rounded-xl overflow-hidden shadow-lg border border-pink-100 bg-white" data-id="element-144">
            <img src="https://cdn.magicpatterns.com/uploads/n96EfXq5cWr3NL6N5jDKB4/Screenshot_2026-02-13_202638.png" alt="Patrón de Movimiento y Técnica" className="w-full h-auto" data-id="element-145" />
          </div>
          <div className="rounded-xl overflow-hidden shadow-lg border border-pink-100 bg-white" data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/oGRVJR9gcq5ZGJYdKQcNo6/Screenshot_2026-02-13_202600.png" alt="Módulo 6 – Rentabilidad y Estructura de Negocio" className="w-full h-auto" data-id="element-147" />
          </div>
        </div>

        <p className="text-center text-sm text-gray-500 mt-8 italic" data-id="element-148">
          * Páginas reales del material incluido en el MegaPack Estética
          Integral
        </p>
      </div>
    </section>;
}